import { FunctionComponent, useState } from 'react'
import Icon from '@/components/HeroIcons'
import { useStyles } from './styles'
import { RenderIf } from '../RenderIf'

interface ProfessionalAvatarProps {
  picture?: string
  name: string
  speciality?: string
  withArrow?: boolean
}

const ProfessionalAvatar: FunctionComponent<
  ProfessionalAvatarProps
> = props => {
  const {
    picture,
    name = 'Aguardando definição',
    speciality,
    withArrow,
  } = props
  const [imgLoaded, setImgLoaded] = useState(true)

  const styles = useStyles()

  return (
    <div css={styles.wrapper}>
      <div css={styles.content} className="professional-avatar-container">
        {picture && imgLoaded ? (
          <img
            css={styles.avatar}
            src={picture}
            alt={name}
            onError={() => {
              setImgLoaded(false)
            }}
          />
        ) : (
          <span css={styles.defaultAvatar}>
            <Icon name="profile" themeColor={['neutral', '500']} />
          </span>
        )}

        <div css={styles.professionalInfo}>
          <h5 className="text-capitalize">{name}</h5>
          {speciality && <span>{speciality}</span>}
        </div>
      </div>

      <RenderIf condition={withArrow}>
        <Icon name="arrow-right" css={styles.arrowIcon} />
      </RenderIf>
    </div>
  )
}

export { ProfessionalAvatar }
